export default __webpack_public_path__ + "static/media/R7SR18.a0d6badf.png";